module.exports = __webpack_public_path__ + "img/WHITE_GEVILLE.3d16ac76.svg";